import { Button, ButtonProps } from 'antd'

interface IconButtonProps extends ButtonProps {
    icon: React.ReactNode
}

const IconButton = (props: IconButtonProps) => {
    const { icon, shape = 'circle', size = 'middle', ...rest } = props

    return <Button {...rest} icon={icon} size={size} shape={shape} />
}

export default IconButton
